import React from "react";
import {
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
  OffcanvasProps,
} from "reactstrap";
import "./style.scss";

export interface CustomDrawerProps extends OffcanvasProps {
  title?: string;
  children?: any;
  footer?: any;
  isOpen: boolean;
  onHide: () => void;
}
const CustomDrawer = ({
  title,
  footer,
  isOpen,
  onHide,
  direction = "end",
  children,
  ...rest
}: CustomDrawerProps) => {
  return (
    <React.Fragment>
      <Offcanvas
        className="custom-drawer"
        size="lg"
        scrollable={true}
        direction={direction}
        isOpen={isOpen}
        toggle={() => onHide()}
        {...rest}
      >
        {title && (
          <OffcanvasHeader toggle={() => onHide()}>{title}</OffcanvasHeader>
        )}
        <OffcanvasBody>{children}</OffcanvasBody>
      </Offcanvas>
    </React.Fragment>
  );
};

export default CustomDrawer;
